(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", () => {
    const items = document.querySelectorAll(".timeline-wrapper .item");
    const steps = document.querySelectorAll(".timeline-steps li");

    function showItem(index) {
        items.forEach((item, i) => {
        item.classList.toggle("active", i === index);
        item.style.display = i === index ? "flex" : "none";
        });
        steps.forEach((step, i) => {
        step.classList.toggle("active", i === index);
        });
    }

    showItem(0); // show first item

    steps.forEach((step, index) => {
        step.addEventListener("click", () => showItem(index));
    });
    });


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".image-slider").forEach(slider => {
    const images = slider.querySelectorAll(".image");
    const total = images.length;
    let index = 0;
    const intervalTime = 3000;
    let timer, startTime, animationFrame;

    // Create progress segments
    const barWrapper = document.createElement("div");
    barWrapper.className = "progress-bar-wrapper";
    const segments = [];

    for(let i=0;i<total;i++){
      const seg = document.createElement("div");
      seg.className = "progress-segment";
      const fill = document.createElement("div");
      fill.className = "progress-fill";
      seg.appendChild(fill);
      barWrapper.appendChild(seg);
      segments.push({seg, fill});

      // Click to jump
      seg.addEventListener("click", () => {
        index = i;
        showImage(index);
        resetTimer();
      });
    }
    slider.appendChild(barWrapper);

    function showImage(i){
      images.forEach((img, idx) => img.classList.toggle("active", idx===i));
      segments.forEach((s, idx)=>{
        s.fill.style.width = idx < i ? "100%" : "0%";
      });
      startTime = performance.now();
    }

    function animateBar(time){
      const elapsed = time - startTime;
      const percent = Math.min(elapsed / intervalTime * 100, 100);
      segments[index].fill.style.width = percent + "%";
      animationFrame = requestAnimationFrame(animateBar);
    }

    function next(){
      index = (index+1)%total;
      showImage(index);
    }

    function resetTimer(){
      clearInterval(timer);
      cancelAnimationFrame(animationFrame);
      startTime = performance.now();
      timer = setInterval(next, intervalTime);
      animationFrame = requestAnimationFrame(animateBar);
    }

    showImage(index);
    timer = setInterval(next, intervalTime);
    animationFrame = requestAnimationFrame(animateBar);
  });
});


  } catch(e) { console.error(e); }
})();
})();
